import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaDownload } from 'react-icons/fa';

const HeroV2 = () => {
  const badges = [
    'SaaS Architecture',
    'API Development',
    'Multi-tenant Systems',
    'High Performance Laravel',
  ];

  return (
    <section className="py-16 md:py-20 lg:py-24 min-h-[65vh] md:min-h-[75vh] lg:min-h-[80vh] bg-gradient-to-br from-slate-950 via-blue-900 to-indigo-900 text-white flex items-center">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
          viewport={{ once: true }}
          className="space-y-6 md:space-y-8 text-center flex flex-col items-center justify-center py-32"
        >
          <p className="text-blue-200 uppercase tracking-[0.2em] text-xs font-semibold">Portfolio V2</p>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight leading-tight">
            Shalender Kumar
          </h1>
          <p className="text-lg md:text-xl text-blue-200 font-semibold">
            Senior Laravel Engineer
          </p>
          <p className="text-sm md:text-base text-gray-200 leading-relaxed max-w-2xl mx-auto">
            Senior Laravel Engineer specializing in scalable SaaS platforms, API-driven systems, and high-performance backend architectures.
          </p>
          <p className="text-sm md:text-base text-gray-200 leading-relaxed max-w-2xl mx-auto">
            11+ years building production systems for SaaS platforms, enterprise systems, and large scale backend services.
          </p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            viewport={{ once: true }}
            className="flex flex-wrap gap-3 pt-2 justify-center"
          >
            {badges.map((badge) => (
              <span
                key={badge}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/25 text-sm md:text-base"
              >
                <FaCheckCircle className="text-emerald-300" />
                {badge}
              </span>
            ))}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.25 }}
            viewport={{ once: true }}
            className="flex flex-col sm:flex-row gap-3 pt-4 justify-center w-full"
          >
            <a
              href="#projects-v2"
              className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-blue-500 hover:bg-blue-400 text-white font-semibold shadow-md hover:-translate-y-2 transition-all duration-300 w-full sm:w-auto"
            >
              View Projects
            </a>
            <a
              href="/resume/shalender-kumar-resume.pdf"
              download
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-white text-slate-900 font-semibold shadow-md hover:-translate-y-2 transition-all duration-300 w-full sm:w-auto"
            >
              <FaDownload />
              Download Resume
            </a>
            <a
              href="#contact-v2"
              className="inline-flex items-center justify-center px-6 py-3 rounded-lg border border-white/40 bg-white/10 hover:bg-white/20 text-white font-semibold shadow-md hover:-translate-y-2 transition-all duration-300 w-full sm:w-auto"
            >
              Contact Me
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroV2;
